import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "components/CustomButtons/Button.js";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { Grid } from "@material-ui/core"
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { getPreviousDateAccToDays } from "utils/Utils";
import { removeUnderscores } from "utils/Utils";
import { useNavigate } from "react-router-dom";
import { SearchTable } from "utils/Utils";
import { rejectedTableColumns } from "assets/properties/properties";
import { getApplicationFromDate } from "assets/properties/properties";
import useApplicantStatusData from "hooks/useApplicantStatusData";

const Rejected = ({seletedBranchCode, featureFlags}) => {

  const [selectedTableData, setSelectedTableData] = useState([]);
  const navigate = useNavigate();
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [totalCollateralValue,setTotalCollateralValue]=useState("")
  const [editableModal, setEditableModal] = useState(false);
  const [loanAPPLICATIONID, setLoanAPPLICATIONID] = useState("");
  const [status, setStatus] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [loanAccountNumber, setLoanAccountNumber] = useState("")
  const[customerProceedId, setCustomerProceedId]= useState('')
  const [loanType, setLoanType]= useState("");
  const [showLinkedLoanBranchFlag, setShowLinkedLoanBranchFlag] = useState(false);
  const [fromDate,setFromDate] = useState(getApplicationFromDate());
  const [toDate,setToDate] = useState(new Date());
  const [rawData, setRawData] = useState([]);
  const handleFromDateChange = (e) => {
    setFromDate(e)
  }
  const handleToDateChange = (e) => {
    setToDate(e)
  }
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const {
    data: applicantData,
    error: applicantDataError,
    callInProgress: applicantDataLoading,
  } = useApplicantStatusData({
    status: "REJECTED&b",
    fromDate,
    toDate,
    authToken,
    featureFlags,
  });
  useEffect(() => {
    if (featureFlags) {
      parseFlags(featureFlags.showLinkedLoanBranchFlag, setShowLinkedLoanBranchFlag);
    }
  }, [featureFlags]);
  const parseFlags = (flag, setStateFunction) => {
    const parsedFlag = typeof flag === "boolean" ? flag : flag === "true";
    setStateFunction(parsedFlag);
  };
  const [tableColumns, setTableColumns] = useState(rejectedTableColumns);
  useEffect(() => {
    setTableColumns(prevList =>
        prevList.map(item => {
            switch (item.id) {
                case "linkedBranch":
                    return { ...item, show: showLinkedLoanBranchFlag };
                default:
                    return item;
            }
        })
    );
  }, [
    showLinkedLoanBranchFlag
  ]);
  
  const visibleDeliverables = tableColumns.filter(item => item.show);
  const [subStatus,setSubStatus] =useState("")

  useEffect(() => {
    if (applicantDataError) {
      toastUpdate("Error", applicantDataError.user_description, true);
    } else {
      parseIndicatorData(applicantData);
      setRawData(applicantData);
    }
  }, [applicantData, applicantDataError]);

  const parseIndicatorData = (data) => {
    let reportData = [];
    data = data.sort((a, b) =>
      a.loanApplicationId < b.loanApplicationId ? 1 : -1
    );
    data &&
      data.forEach((RejectedApplication, index) => {
        let row = {
          applicationid: RejectedApplication.loanApplicationId,
          created: RejectedApplication.createdBy,
          formNumber:RejectedApplication.loanApplicationNumber,
          accountNumber:RejectedApplication.loanAccountNumber,
          linkedBranch: RejectedApplication.linkedLoanBranchName,
          customerid:RejectedApplication.customerId,
          customerName:RejectedApplication.customerName,
          branchCode: RejectedApplication.branchCode,
          type: `${removeUnderscores(RejectedApplication?.applicationType)} / ${removeUnderscores(RejectedApplication?.applicationSubType)}`,
          totalCollateralValue:RejectedApplication?.totalCollateralValue,
          productType: RejectedApplication?.productType,
          // action:GetAction(
          //   RejectedApplication.loanApplicationId,
          //   RejectedApplication.customerId,
          //   RejectedApplication.loanAccountNumber,
          // ),
          };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  const GetAction = (loanApplicationId, customerProcessId, loanAccNumber, totalCollateralValue) => {
    return (
      <>
        <Button
          aria-label="Edit Branch"
          onClick={() => onClickUpdateData(loanApplicationId, customerProcessId, loanAccNumber)}
          color="info"
        >
          View
        </Button>
      </>
    );
  };
  const onClickUpdateData = async (loanApplicationId, customerProcessId, loanAccNumber, productType) => {
    const result = await apiHandler({
      url:
      endpoint.LOAN_STATUS + `?loanApplicationId=${loanApplicationId}` ,
      authToken: authToken,
    });
    const prepledgeLoanMap = result?.data?.prepledgeLoanMap || [];
    const prepledgeLoanAccountNumber = result?.data?.prepledgeLoanAccountNumber ? result?.data?.prepledgeLoanAccountNumber : Object.keys(prepledgeLoanMap || {})?.[0]
      setLoanAPPLICATIONID(loanApplicationId);
      setStatus("REJECTED");
      setTotalCollateralValue(totalCollateralValue);
      setLoanAccountNumber(loanAccNumber)
      setCustomerProceedId(customerProcessId)
      setSubStatus(result?.data?.applicationSubType ?result?.data?.applicationSubType :"")
      setLoanType(result?.data?.applicationType ? result?.data?.applicationType :"");
          const navigationData = {
          loanApplicationId:loanApplicationId,
          status:"REJECTED",
          subStatus:result?.data?.applicationSubType,
          editable:editableModal,
          prePledgeLoan:prepledgeLoanAccountNumber,
          customerProceedId:customerProcessId,
          loanAccountNumber:loanAccNumber,
          loanType:result?.data?.applicationType,
          totalCollateralValue:totalCollateralValue,
          seletedBranchCode:seletedBranchCode,
          prepledgeLoanMap:prepledgeLoanMap,
          productType
    };
      navigate(`/fieldAgent/${loanApplicationId}`, { state: navigationData });
  };
  const onSearchChange = (event) => {
      const filteredData = SearchTable(
        rawData,
        ["loanAccountNumber", "customerName", "customerId", "loanApplicationNumber","branchCode"],
        event?.target?.value
      );
      parseIndicatorData(filteredData);
    };

  return (
    <Grid container>
    <Grid item xs={12} sm={12} md={12}>
      <SubHeader
        label=" Rejected"
        onSearchChange={onSearchChange}
        searchLabel="Search For Details"
        search
        searchCriteria
        handleFromDateChange={handleFromDateChange}
        fromDate={fromDate}
        handleToDateChange={handleToDateChange}
        toDate={toDate}
      />
    </Grid>

    <Grid item xs={12} sm={12} md={12}>
      <ColumnGroupingTable columns={visibleDeliverables} rows={selectedTableData} onClickUpdateData={onClickUpdateData} flag="rejected"/>
    </Grid>
    {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
        {applicantDataLoading && <CircularProgresss callInProgress />}
</Grid>
  );
};

Rejected.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
};

export default Rejected;
